export default __webpack_public_path__ + "static/media/problema-09.7e12ba50.webp";